<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div class="auth-wrapper auth-v2">
      <b-row class="auth-inner m-0">
        <!-- Left Text-->
        <b-col
            class="d-none d-lg-flex align-items-center p-5"
            lg="8"
        >
          <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
            <b-img
                :src="imgUrl"
                alt="Login V2"
                fluid
            />
          </div>
        </b-col>
        <!-- /Left Text-->

        <!-- Login-->
        <b-col
            class="d-flex align-items-center auth-bg px-2 p-lg-5"
            lg="4"
        >
          <b-col
              class="px-xl-2 mx-auto"
              lg="12"
              md="6"
              sm="8"
          >
            <b-card-title
                class="mb-1 font-weight-bold"
                title-tag="h2"
            >
              Welcome to {{ appName }}! 👋
            </b-card-title>
            <b-card-text class="mb-2">
              Please sign-in to your account and start the adventure
            </b-card-text>


            <!-- form -->
            <validation-observer
                ref="loginForm"
                #default="{invalid}"
            >
              <b-form
                  class="auth-login-form mt-2"
                  @submit.prevent="login"
              >
                <!-- email -->
                <b-form-group
                    label="user name"
                    label-for="login-username"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="username"
                      rules="required"
                      vid="email"
                  >
                    <b-form-input
                        id="login-username"
                        v-model="loginPayload.username"
                        :state="errors.length > 0 ? false:null"
                        name="login-username"
                        placeholder="Your username..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <!--                  <div class="d-flex justify-content-between">-->
                  <!--                    <label for="login-password">Password</label>-->
                  <!--                    <b-link :to="{name:'auth-forgot-password'}">-->
                  <!--                      &lt;!&ndash;                    <small>Forgot Password?</small>&ndash;&gt;-->
                  <!--                    </b-link>-->
                  <!--                  </div>-->
                  <validation-provider
                      #default="{ errors }"
                      name="Password"
                      rules="required"
                      vid="password"
                  >
                    <b-input-group
                        :class="errors.length > 0 ? 'is-invalid':null"
                        class="input-group-merge"
                    >
                      <b-form-input
                          id="login-password"
                          v-model="loginPayload.password"
                          :state="errors.length > 0 ? false:null"
                          :type="passwordFieldType"
                          class="form-control-merge"
                          name="login-password"
                          placeholder="*****"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                            :icon="passwordToggleIcon"
                            class="cursor-pointer"
                            @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- checkbox -->
                <b-form-group>
                  <b-form-checkbox
                      id="remember-me"
                      v-model="status"
                      name="checkbox-1"
                  >
                    Remember Me
                  </b-form-checkbox>
                </b-form-group>

                <!-- submit buttons -->
                <b-button
                    :disabled="invalid"
                    block
                    type="submit"
                    variant="primary"
                >
                  Sign In
                </b-button>

              </b-form>
            </validation-observer>
          </b-col>
        </b-col>
        <!-- /Login-->
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
/* eslint-disable global-require */
import appName from '@/main'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BAlert,
  BButton,
  BCardText,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BOverlay,
  BRow,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { email, integer, required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  title: 'Login',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    BOverlay,

    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      appName,
      status: '',
      loginPayload: {
        username: '',
        password: ''
      },
      showOverlay: false,
      userAbilities: {
        Admin: {
          action: 'manage',
          subject: 'admin',
        },
        SuperAdmin: {
          action: 'manage',
          subject: 'all',
        }
      },
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      required,
      integer,
      email
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate()
          .then(success => {
            if (success) {
              this.showOverlay = true
              useJwt.login(this.loginPayload)
                  .then(response => {
                    this.showOverlay = false
                    // Success

                    const userData = response.data.data.user
                    if (!this.userAbilities[userData.roles[0]]) {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'bottom-center',
                        props: {
                          title: `Failed`,
                          icon: 'CloseIcon',
                          variant: 'danger',
                          text: `You Don't Have Access To This Panel`,
                        },
                      })
                    } else {
                      userData['ability'] = [this.userAbilities[userData.roles[0]]]
                      useJwt.setToken(response.data.data.accessToken.access_token)
                      useJwt.setRefreshToken(response.data.data.accessToken.refresh_token)
                      localStorage.setItem('userData', JSON.stringify(userData))
                      this.$ability.update(userData.ability)
                      // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
                      this.$router.replace(getHomeRouteForLoggedInUser(userData.roles[0]))
                          .then(() => {
                            this.$toast({
                              component: ToastificationContent,
                              props: {
                                title: `${userData.userName}`,
                                icon: 'CoffeeIcon',
                                variant: 'success',
                                text: `You have successfully logged in as ${userData.roles[0]}. Now you can start to explore!`,
                              },
                            })
                          })
                    }
                  })
                  .catch(error => {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        variant: 'danger',
                        text: error.response.data.message,
                      },
                    })
                    this.showOverlay = false
                  })
            }
          })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
